export const isStepDependencyPaused = (orderedStepsDependencyInfo, dependsOnTaskId) => {
    return orderedStepsDependencyInfo.find(d => d.id === dependsOnTaskId)?.paused;
}
